
export default {
  props: {
    loadingText: {
      type: String,
      default: "正在加载…",
    },
  },
};
